/**
 * @generated SignedSource<<22dcadf347f65fc24be0d5ab7a2c4e72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TimeOffAffectedProjectsQuery$variables = {
  personId: number;
};
export type TimeOffAffectedProjectsQuery$data = {
  readonly current_user: {
    readonly account: {
      readonly id: number;
      readonly people: ReadonlyArray<{
        readonly id: number;
        readonly project_memberships: ReadonlyArray<{
          readonly id: number;
          readonly project: {
            readonly id: number;
            readonly summary: ReadonlyArray<{
              readonly minutes_phase_id: number | null | undefined;
              readonly person_id: number | null | undefined;
              readonly project_id: number | null | undefined;
              readonly role_id: number | null | undefined;
              readonly total_billable_minutes: number | null | undefined;
              readonly total_nonbillable_minutes: number | null | undefined;
            }>;
          };
        }>;
      }>;
    };
    readonly id: number;
  } | null | undefined;
};
export type TimeOffAffectedProjectsQuery = {
  response: TimeOffAffectedProjectsQuery$data;
  variables: TimeOffAffectedProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "users",
    "kind": "LinkedField",
    "name": "current_user",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "_eq",
                        "variableName": "personId"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "id"
                  }
                ],
                "kind": "ObjectValue",
                "name": "where"
              }
            ],
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "people",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "project_members",
                "kind": "LinkedField",
                "name": "project_memberships",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "projects",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "v_summary_total",
                        "kind": "LinkedField",
                        "name": "summary",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "project_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "person_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minutes_phase_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total_billable_minutes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total_nonbillable_minutes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeOffAffectedProjectsQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimeOffAffectedProjectsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4f6dc2302bd10f9abe45d8476890e0d1",
    "id": null,
    "metadata": {},
    "name": "TimeOffAffectedProjectsQuery",
    "operationKind": "query",
    "text": "query TimeOffAffectedProjectsQuery(\n  $personId: Int!\n) {\n  current_user {\n    id\n    account {\n      id\n      people(where: {id: {_eq: $personId}}) {\n        id\n        project_memberships {\n          id\n          project {\n            id\n            summary {\n              project_id\n              person_id\n              role_id\n              minutes_phase_id\n              total_billable_minutes\n              total_nonbillable_minutes\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de08ec8540d78e97460f6a109a8d2617";

export default node;
